// extracted by mini-css-extract-plugin
export default {"container":"input-group__container___12Xy0","cell":"input-group__cell___Ehgox"};